<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Height</label>
      <input 
        v-model="localSettings.height"
        type="text"
        class="form-input"
        placeholder="1px, 2px, 5px"
        @input="emitUpdate"
      />
      <p class="form-help-text">Thickness of the divider</p>
    </div>

    <div class="form-group">
      <label class="form-label">Style</label>
      <select v-model="localSettings.style" class="form-select" @change="emitUpdate">
        <option value="solid">Solid</option>
        <option value="dashed">Dashed</option>
        <option value="dotted">Dotted</option>
        <option value="double">Double</option>
      </select>
    </div>

    <div class="form-group">
      <label class="form-label">Color</label>
      <div class="form-color-input">
        <input 
          v-model="localSettings.color"
          type="color"
          @input="emitUpdate"
        />
        <input 
          v-model="localSettings.color"
          type="text"
          class="form-input"
          placeholder="#e5e7eb"
          @input="emitUpdate"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  height: '1px',
  style: 'solid',
  color: '#e5e7eb',
  class: '',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.form-help-text {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}
</style>

